// extracted by mini-css-extract-plugin
module.exports = {"copyBtn":"style__copyBtn__j6pcL"};